import { Imagen as c } from "../EditPanel/Imagen";
import { conLanding } from "../Models/Landing";

export default class Imagen extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}